import { create } from 'zustand';

type LightningModes = Record<string, boolean>;

interface LightningModeState {
	modes: LightningModes;
	setLightningMode: (game: string, enabled: boolean) => void;
	toggleLightningMode: (game: string) => void;
	resetLightningMode: (game: string) => void;
}

export const useLightningModeStore = create<LightningModeState>((set) => ({
	modes: {},
	setLightningMode: (game: string, enabled: boolean) =>
		set((state) => ({
			modes: { ...state.modes, [game]: enabled },
		})),
	toggleLightningMode: (game: string) =>
		set((state) => {
			const current = state.modes[game] ?? false;
			return {
				modes: { ...state.modes, [game]: !current },
			};
		}),
	resetLightningMode: (game: string) =>
		set((state) => {
			if (!(game in state.modes)) return state;
			const next = { ...state.modes };
			delete next[game];
			return { modes: next };
		}),
}));
